import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'components/organisms/mlb-hitter-stacking/actions';
import {sortArrayOfObjects} from 'helpers/common-helper';
import {parsePlayerExposureValue} from 'helpers/number-helper';
import {getTeamNamesOfGames} from 'helpers/game-helper';
import MultiSelect from 'components/atoms/dropdowns/multi-select';

class StackItem extends Component {
    constructor(props) {
        super(props);
        this.isValueBeingChanged = {
            exposure: false,
        };
        this.state = {
            exposure: '',
        };
    }

    getListOfTeams() {
        const {games} = this.props;

        let teamNames = [];
        if (this.isStateReady(games, 'data')) {
            teamNames = getTeamNamesOfGames(games.getAllAsArr());
        }

        return teamNames;
    }

    selectTeam(e) {
        const {groupNumber, itemNumber} = this.props;
        this.props.dispatch(Action.setHittersStackTeam(groupNumber, itemNumber, e.target.value));
    }

    removeItem() {
        const {groupNumber, itemNumber} = this.props;
        this.props.dispatch(Action.removeHittersStackItem(groupNumber, itemNumber));
    }

    onChangeExposure(value) {
        this.isValueBeingChanged.exposure = true;
        this.setState({exposure: value});
    }

    onBlurExposure(rawValue) {
        const {groupNumber, itemNumber} = this.props;
        const value = parsePlayerExposureValue(rawValue, 'min');

        this.onChangeExposure(value);
        this.isValueBeingChanged.exposure = false;

        this.props.dispatch(Action.setHittersStackExposure(groupNumber, itemNumber, value));
    }

    selectPlayer(playerIds) {
        const {groupNumber, itemNumber} = this.props;

        this.props.dispatch(Action.setHittersStackPlayers(groupNumber, itemNumber, playerIds));
    }

    preparePlayerOptions() {
        const {players, item} = this.props;
        const options = [];

        if (item.team) {
            players.getAllAsArr().map((player) => {
                if (item.team === player.team && !player.isPitcher() && !player.isExcludedAnywhere()) {
                    options.push({
                        value: player.playerId,
                        label: player.name + ' ' + player.positionName,
                    });
                }
            });
        }

        return sortArrayOfObjects(options, 'label', 'asc');
    }

    preparePlayerValues() {
        const {players, item} = this.props;
        const values = [];

        if (!isEmpty(item.playerIds)) {
            item.playerIds.map((playerId) => {
                const player = players.getPlayer(playerId);

                if (player !== null) {
                    values.push({
                        value: player.playerId,
                        label: player.name + ' ' + player.positionName,
                    });
                }
            });
        }

        return values;
    }

    getActualValue(propName) {
        const value = this.state[propName];

        if (this.isValueBeingChanged[propName]) {
            return value;
        }

        if (propName === 'exposure') {
            const {item} = this.props;

            return item.expMin;
        }

        return value;
    }

    render() {
        const {itemNumber, item} = this.props;
        const isFirstItem = 0 >= itemNumber;
        const teams = this.getListOfTeams();
        const playerOptions = this.preparePlayerOptions();
        const playerValues = this.preparePlayerValues();

        return (
            <div className="form-row-new">
                <div className="team">
                    {isFirstItem ? <div className="form-text">Team</div> : null}
                    <select onChange={(e) => ::this.selectTeam(e)} value={item.team} className="form-control">
                        <option value="">Team</option>
                        {teams.map((team) => (
                            <option key={team} value={team}>
                                {team}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="stack">
                    {isFirstItem ? <div className="form-text">Stack</div> : null}
                    <div className="percent-in">
                        <input
                            type="text"
                            className="form-control input-sm"
                            value={this.getActualValue('exposure')}
                            onChange={(e) => ::this.onChangeExposure(e.target.value)}
                            onBlur={(e) => ::this.onBlurExposure(e.target.value)}
                        />
                        <span className="percent">%</span>
                    </div>
                </div>
                <div className="players">
                    {isFirstItem ? <div className="form-text">Players</div> : null}
                    <MultiSelect
                        onSelect={::this.selectPlayer}
                        options={playerOptions}
                        values={playerValues}
                        placeholder={'All players'}
                    />
                </div>
                <div className="delete">
                    {!isFirstItem ? (
                        <button type="button" onClick={::this.removeItem}>
                            <i className="fa fa-times-circle"></i>
                        </button>
                    ) : null}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {playersData, stacks} = state;

    return {
        games: playersData.games,
        players: playersData.players,
        stack: stacks.hitters,
    };
}

export default connect(mapStatesToProps)(StackItem);
